<div class="dialog-container">
  <div class="dialog-title" mat-dialog-title>
    <div class="left-section">
      <span>{{ title }}</span>
    </div>
    <div class="right-section">
      <span class="action-field" (click)="shareByEmail()" (keydown)="handleShareByEmailKeyDown($event)">
        <button class="action_button" mat-icon-button>
          <mat-icon>email</mat-icon>
        </button>
        <span class="action-text">SHARE BY EMAIL</span>
      </span>
      <span class="action-field" (click)="download()" (keydown)="handleDownloadKeyDown($event)">
        <button class="action_button" mat-icon-button>
          <mat-icon>download</mat-icon>
        </button>
        <span class="action-text">DOWNLOAD</span>
      </span>
      <span class="action-field" (click)="delete()" (keydown)="handleDeleteKeyDown($event)">
        <button class="action_button" mat-icon-button>
          <mat-icon>delete</mat-icon>
        </button>
        <span class="action-text">DELETE</span>
      </span>
      <span>        
      <button class="close_button" (click)="close()" mat-icon-button mat-dialog-close>
        <mat-icon>close</mat-icon>
      </button>
      </span>
    </div>
  </div>
  <div class="dialog-content">
    <mat-card-actions class="spinner-overlay">
      @if (isLoading) {
        <mat-progress-spinner
          mode="indeterminate"
          diameter="32"
        ></mat-progress-spinner>
      }
    </mat-card-actions>
    @if (errorMessage) {
      <div class="error-message-wrapper">
        <div>
          <span class="document_name">{{ documentName }}</span
          ><br />
          <span class="error-message">{{ errorMessage }}</span>
        </div>
      </div>
    } @else {
      <div class="pdf-dialog-container">
        @if (documentURL) {
          <ngx-extended-pdf-viewer
            #pdfViewer
            [textLayer]="true"
            [zoom]="zoomLevel"
            [src]="documentURL"
            [showToolbar]="false"
            (pdfLoaded)="onPdfLoaded()"
          ></ngx-extended-pdf-viewer>
        }
      </div>
    }
  </div>
  <div class="zoom-controls">
    <button
      class="zoom-btn"
      [disabled]="zoomLevel >= maxZoom"
      (click)="zoomIn()"
      mat-fab
      color="primary"
    >
      <mat-icon>zoom_in</mat-icon>
    </button>
    <button
      class="zoom-btn"
      [disabled]="zoomLevel <= minZoom"
      (click)="zoomOut()"
      mat-fab
      color="primary"
    >
      <mat-icon>zoom_out</mat-icon>
    </button>
  </div>
  <div class="dialog-footer">
    <button
      class="footer-btn left"
      [disabled]="currentIndex === 0"
      (click)="previous()"
      mat-button
    >
      <mat-icon>chevron_left</mat-icon> Previous
    </button>
    <button class="footer-btn center" (click)="close()" mat-button>
      <mat-icon>close</mat-icon>Close
    </button>
    <button
      class="footer-btn right"
      [disabled]="currentIndex === documents.length - 1"
      (click)="next()"
      mat-button
    >
      Next <mat-icon>chevron_right</mat-icon>
    </button>
  </div>
</div>
